import { createRouter, createWebHistory } from 'vue-router'
import CategoryView from '../views/CategoryView.vue'
import { local, STORAGE_KEYS } from '@/utils/storage'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'duties' }
  },
  {
    path: '/home-map',
    name: 'home-map',
    component: () => import('../views/HomeMapView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/LogoutView.vue')
  },
  {
    path: '/2fa',
    name: 'two-factor-verify',
    component: () => import('../views/TwoFactorVerify.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/duties',
    name: 'duties',
    component: () => import('../views/Duties.vue')
  },
  {
    path: '/duties-detail/:missionId/:locationId',
    name: 'duties-detail',
    component: () => import('../views/DutiesDetail.vue')
  },
  {
    path: '/duties-rules',
    name: 'duties-rules',
    component: () => import('../views/StaticPageView.vue'),
    props: { slug: 'duties-rules' }
  },
  {
    path: '/pages/:slug',
    name: 'static-page',
    component: () => import('../views/StaticPageView.vue')
  },
  {
    // Etkinlik alanındaki ekranda gösterilen QR; oturum gerektirmez, uygulama kabuğu (menü, popup vb.) gösterilmez.
    path: '/qr/:code',
    name: 'qr-display',
    component: () => import('../views/QrDisplayView.vue'),
    meta: { kiosk: true }
  },
  {
    path: '/category',
    name: 'category',
    component: CategoryView
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/achievements',
    name: 'achievements',
    component: () => import('../views/AchievementsView.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/EventsView.vue')
  },
  {
    path: '/new-password/:resetToken',
    name: 'new-password',
    component: () => import('../views/NewPassword.vue')
  },
  {
    path: '/profile-password',
    name: 'profile-password',
    component: () => import('../views/profilePassword.vue')
  },
  {
    path: '/profile-contact',
    name: 'profile-contact',
    component: () => import('../views/profileContact.vue')
  },
  {
    path: '/on-google-auth',
    name: 'on-google-auth',
    component: () => import('../views/SocialAuth.vue')
  },
  {
    path: '/activate-user/:token',
    name: 'activate-user',
    component: () => import('../views/ActivateUserView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const CHUNK_RELOAD_FLAG = 'coridor:chunk-reload-attempted'

function isChunkLoadError (error) {
  const message = error?.message || ''

  return (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('failed') ||
    message.includes('Failed to fetch dynamically imported module')
  )
}

export const PUBLIC_ROUTE_NAMES = new Set([
  'login',
  'register',
  'forgot-password',
  'new-password',
  'activate-user',
  'on-google-auth',
  'logout',
  'two-factor-verify',
  'qr-display'
])

router.beforeEach((to, _from, next) => {
  if (PUBLIC_ROUTE_NAMES.has(to.name)) {
    return next()
  }

  const isLoggedIn = local.get(STORAGE_KEYS.IS_LOGIN) === 'true'

  if (!isLoggedIn) {
    return next({ name: 'login' })
  }

  next()
})

router.afterEach(() => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(CHUNK_RELOAD_FLAG)
  }
})

router.onError((error) => {
  if (typeof window === 'undefined' || !isChunkLoadError(error)) {
    return
  }

  const hasRetried = window.sessionStorage.getItem(CHUNK_RELOAD_FLAG) === 'true'

  if (hasRetried) {
    window.sessionStorage.removeItem(CHUNK_RELOAD_FLAG)
    return
  }

  window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, 'true')
  window.location.reload()
})

export default router
